import LiveAccordionContainer from './live-accordion';

export default LiveAccordionContainer;
